import React, { useState } from 'react';
import './Styles.css';
import MenuList from '../../../Elements/MenuList';
import MenuListItem from '../../../Elements/MenuListItem';
import { formatMessage } from '../../../Localization/formatMessage';
import Messages from '../../../Localization/Messages';
import { employerModalType } from '../EmployerModalType';
import { PresentationMode } from '../../../Enums/PresentationMode';
import { getFormattedAddress } from '../../../Helpers/AddressHelper';
import ThreeDotIcon from '../../../Elements/ids/ThreeDotIcon';

const EmployerHeader = ({ employer, setOpenedModal, pageMode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const getValue = value => {
    return value ?? formatMessage(Messages.common_missingValue);
  };

  return (
    <div className="employerPage-headerContainer">
      <div className="employerPage-headerContainer-items">
        <div className="employerPage-headerContainer-firstItem">
          <img aria-hidden className="if size-32" src="/assets/worker24.svg" alt="Employer" />
        </div>
        <div>
          <div className="employerPage-headerContainer-itemTitle">{formatMessage(Messages.common_name)}</div>
          <div>{getValue(employer.name)}</div>
        </div>
        <div>
          <div className="employerPage-headerContainer-itemTitle">{formatMessage(Messages.common_mobile)}</div>
          <div>{getValue(employer.mobile)}</div>
        </div>
        <div>
          <div className="employerPage-headerContainer-itemTitle">{formatMessage(Messages.common_phone)}</div>
          <div>{getValue(employer.phone)}</div>
        </div>
        <div>
          <div className="employerPage-headerContainer-itemTitle">{formatMessage(Messages.common_email)}</div>
          <div>{getValue(employer.email)}</div>
        </div>
        <div>
          <div className="employerPage-headerContainer-itemTitle">{formatMessage(Messages.common_country)}</div>
          <div>{getValue(employer.country?.name)}</div>
        </div>
        <div>
          <div className="employerPage-headerContainer-itemTitle">{formatMessage(Messages.common_address)}</div>
          <div>{getFormattedAddress(employer.address)}</div>
        </div>
        <div className="employerPage-headerContainer-lastItem">
          <ThreeDotIcon
            onClick={() => {
              setIsOpen(true);
            }}
          />
        </div>

        <MenuList
          isOpen={isOpen}
          onOutsideClick={() => {
            setIsOpen(false);
          }}>
          <MenuListItem
            text={formatMessage(Messages.common_edit)}
            onClick={() => {
              setOpenedModal(employerModalType.EmployerInfo);
              setIsOpen(false);
            }}
          />
          {pageMode !== PresentationMode.Add && (
            <>
              <MenuListItem
                text={formatMessage(Messages.employerPage_header_editAddress)}
                onClick={() => {
                  setOpenedModal(employerModalType.AddressInfo);
                  setIsOpen(false);
                }}
              />
              <MenuListItem
                text={formatMessage(Messages.employerPage_header_connectedTeams)}
                onClick={() => {
                  setOpenedModal(employerModalType.ConnectedTeams);
                  setIsOpen(false);
                }}
              />
            </>
          )}
        </MenuList>
      </div>
    </div>
  );
};

export default EmployerHeader;
